import React from 'react';

function Navbar() {
  return (
    <nav className="navbar">
      <h2>Shishir Devkota</h2>
      <ul>
        <li><a href="#projects">Projects</a></li>
        <li><a href="#resume">Resume</a></li>
        <li><a href="#contact">Contact</a></li>
      </ul>
    </nav>
  );
}

export default Navbar;
